import { useMemo } from 'react';

import { GatewayRuleFieldChip } from 'pages/GatewayRules/components/GatewayRuleField/GatewayRuleFieldChip';
import { useGatewayRuleConditions } from 'pages/GatewayRules/context/GatewayRuleConditionsContext';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

type Props = {
  codes: string[];
};

export function GatewayRuleFieldExpressionParamCountry({ codes }: Props): JSX.Element {
  const { countriesByCode } = useGatewayRuleConditions();

  const countriesValue = useMemo(
    () => codes?.map((code) => countriesByCode.get(code)?.name).join(', '),
    [countriesByCode, codes],
  );

  if (!countriesByCode.size) {
    return <></>;
  }

  return (
    <Tooltip
      placement="bottom-start"
      title={<Typography fontSize={11}>{countriesValue}</Typography>}
    >
      <GatewayRuleFieldChip label={countriesValue} />
    </Tooltip>
  );
}
